// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal-specific styling for forget password */
.Login {
  background-color: transparent;
  height: auto;
  min-height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
}
.Login p {
  font-size: 22px !important;
}

.alert-danger {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
  width: 85%;
  margin: 0px auto 1rem;
  font-family: "Raleway";
  font-size: 13px;
}

#formContent {
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 20px;
  width: 100%;
  max-width: 450px;
  position: relative;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  text-align: center;
  border: 1px solid lightgray;
  margin: 0 auto;
}
#formContent .top-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 23px 0 33px;
  margin: 0;
}
#formContent .top-head .auth-modal-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: none;
  border-radius: 50%;
  margin-left: auto;
  margin-right: 0;
  padding: 0;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}
#formContent .top-head .auth-modal-close:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
#formContent .top-head .auth-modal-close mat-icon {
  color: #606060;
  font-size: 20px;
  width: 20px;
  height: 20px;
  transition: color 0.2s ease;
}
#formContent .top-head .auth-modal-close:hover mat-icon {
  color: #333;
}
#formContent input {
  margin-bottom: 20px;
  color: rgba(0, 0, 0, 0.54) !important;
  font-size: 16px;
  background: #fff;
  border: 1px solid lightgray;
}
#formContent input::-webkit-input-placeholder {
  color: rgba(0, 0, 0, 0.54) !important;
}
#formContent input::-moz-placeholder {
  color: rgba(0, 0, 0, 0.54) !important;
}
#formContent input:-ms-input-placeholder {
  color: rgba(0, 0, 0, 0.54) !important;
}
#formContent input:-moz-placeholder {
  color: rgba(0, 0, 0, 0.54) !important;
}
#formContent button {
  font-family: "Raleway";
  background-color: #5ea1d8;
  font-size: 15px;
  cursor: pointer;
  color: white;
  padding: 10px;
  border-radius: 10px;
}

input[type=text],
input[type=password] {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  transition: all 0.5s ease-in-out;
  border-radius: 5px 5px 5px 5px;
}

input[type=text]:focus,
input[type=password]:focus {
  background-color: #fff;
  border-bottom: 2px solid #5fbae9;
}

/* ANIMATIONS */
.fadeIn {
  opacity: 0;
  animation: fadeIn ease-in 1;
  animation-fill-mode: forwards;
  animation-duration: 1s;
}

.fadeIn.first {
  animation-delay: 0.4s;
}

.fadeIn.second {
  animation-delay: 0.6s;
  border: 0.5px solid lightgrey;
}

.fadeIn.fourth {
  animation-delay: 1s;
  border: 0.5px solid lightgrey;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.img-div-left {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10002;
}

@media (max-width: 460px) {
  .Login > div {
    width: calc(100% - 30px);
  }
  #formContent {
    width: 100% !important;
  }
  #formContent input {
    width: calc(100% - 30px);
  }
  #formContent .alert-danger {
    width: calc(100% - 30px) !important;
  }
  #formContent .top-head {
    padding: 20px 6px 0 5px;
  }
  .alert-danger {
    width: calc(100% - 30px) !important;
    margin: 0px auto 1rem;
  }
}
:host-context(body.theme-dark) .Login {
  background-color: #0a0c10 !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) #formContent {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4) !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) #formContent .top-head {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) #formContent input {
  background: #111827 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) #formContent input::-webkit-input-placeholder {
  color: rgba(229, 231, 235, 0.5) !important;
}
:host-context(body.theme-dark) #formContent input::-moz-placeholder {
  color: rgba(229, 231, 235, 0.5) !important;
}
:host-context(body.theme-dark) #formContent input:-ms-input-placeholder {
  color: rgba(229, 231, 235, 0.5) !important;
}
:host-context(body.theme-dark) #formContent input:-moz-placeholder {
  color: rgba(229, 231, 235, 0.5) !important;
}
:host-context(body.theme-dark) #formContent .auth-modal-close mat-icon {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) #formContent .auth-modal-close:hover {
  background-color: rgba(255, 255, 255, 0.08) !important;
}
:host-context(body.theme-dark) #formContent .auth-modal-close:hover mat-icon {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) input[type=text],
:host-context(body.theme-dark) input[type=password] {
  background-color: #111827 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) input[type=text]:focus,
:host-context(body.theme-dark) input[type=password]:focus {
  background-color: #1f2937 !important;
  border-bottom-color: #5ea1d8 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/forget-password-modal/forget-password-modal.component.scss"],"names":[],"mappings":"AAAA,+CAAA;AACA;EACE,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AACF;AACE;EACE,0BAAA;AACJ;;AAGA;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,UAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;AAAF;;AAGA;EAEE,kCAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EAEA,iDAAA;EACA,kBAAA;EACA,2BAAA;EACA,cAAA;AAAF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBAAA;EACA,SAAA;AAAJ;AAEI;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;AAAN;AAEM;EACE,qCAAA;AAAR;AAGM;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;AADR;AAIM;EACE,WAAA;AAFR;AAOE;EACE,mBAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;AALJ;AAMI;EACE,qCAAA;AAJN;AAMI;EACE,qCAAA;AAJN;AAMI;EACE,qCAAA;AAJN;AAMI;EACE,qCAAA;AAJN;AAQE;EACE,sBAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AANJ;;AAUA;;EAEE,yBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EAKA,gCAAA;EAEA,8BAAA;AAPF;;AAUA;;EAEE,sBAAA;EACA,gCAAA;AAPF;;AAUA,eAAA;AACA;EACE,UAAA;EAGA,2BAAA;EAIA,6BAAA;EAIA,sBAAA;AATF;;AAYA;EAGE,qBAAA;AATF;;AAYA;EAGE,qBAAA;EACA,6BAAA;AATF;;AAYA;EAGE,mBAAA;EACA,6BAAA;AATF;;AAYA;EACE;IACE,UAAA;EATF;EAWA;IACE,UAAA;EATF;AACF;AAYA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,cAAA;AAVF;;AAaA;EAEI;IACE,wBAAA;EAXJ;EAeA;IACE,sBAAA;EAbF;EAcE;IACE,wBAAA;EAZJ;EAcE;IACE,mCAAA;EAZJ;EAcE;IACE,uBAAA;EAZJ;EAgBA;IACE,mCAAA;IACA,qBAAA;EAdF;AACF;AAkBE;EACE,oCAAA;EACA,yBAAA;AAhBJ;AAmBE;EACE,8BAAA;EACA,iDAAA;EACA,oDAAA;EACA,yBAAA;AAjBJ;AAmBI;EACE,yBAAA;AAjBN;AAoBI;EACE,8BAAA;EACA,yBAAA;EACA,iDAAA;AAlBN;AAoBM;EAA+B,0CAAA;AAjBrC;AAkBM;EAAsB,0CAAA;AAf5B;AAgBM;EAA0B,0CAAA;AAbhC;AAcM;EAAqB,0CAAA;AAX3B;AAcI;EACE,yBAAA;AAZN;AAeI;EACE,sDAAA;AAbN;AAgBI;EACE,yBAAA;AAdN;AAkBE;;EAEE,oCAAA;EACA,yBAAA;EACA,iDAAA;AAhBJ;AAmBE;;EAEE,oCAAA;EACA,uCAAA;AAjBJ","sourcesContent":["/* Modal-specific styling for forget password */\n.Login {\n  background-color: transparent;\n  height: auto;\n  min-height: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  // padding: 20px;\n  p {\n    font-size: 22px !important;\n  }\n}\n\n.alert-danger {\n  color: #721c24;\n  background-color: #f8d7da;\n  border-color: #f5c6cb;\n  width: 85%;\n  margin: 0px auto 1rem;\n  font-family: \"Raleway\";\n  font-size: 13px;\n}\n\n#formContent {\n  -webkit-border-radius: 10px 10px 10px 10px;\n  border-radius: 10px 10px 10px 10px;\n  background: #fff;\n  padding: 20px;\n  width: 100%;\n  max-width: 450px;\n  position: relative;\n  -webkit-box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n  box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n  text-align: center;\n  border: 1px solid lightgray;\n  margin: 0 auto;\n\n  .top-head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 20px 23px 0 33px;\n    margin: 0;\n    \n    .auth-modal-close {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      width: 32px;\n      height: 32px;\n      border: none;\n      background: none;\n      border-radius: 50%;\n      margin-left: auto;\n      margin-right: 0;\n      padding: 0;\n      cursor: pointer;\n      transition: all 0.2s ease;\n      flex-shrink: 0;\n      \n      &:hover {\n        background-color: rgba(0, 0, 0, 0.05);\n      }\n      \n      mat-icon {\n        color: #606060;\n        font-size: 20px;\n        width: 20px;\n        height: 20px;\n        transition: color 0.2s ease;\n      }\n      \n      &:hover mat-icon {\n        color: #333;\n      }\n    }\n  }\n\n  input {\n    margin-bottom: 20px;\n    color: rgba(0, 0, 0, 0.54) !important;\n    font-size: 16px;\n    background: #fff;\n    border: 1px solid lightgray;\n    &::-webkit-input-placeholder {\n      color: rgba(0, 0, 0, 0.54) !important;\n    }\n    &::-moz-placeholder {\n      color: rgba(0, 0, 0, 0.54) !important;\n    }\n    &:-ms-input-placeholder {\n      color: rgba(0, 0, 0, 0.54) !important;\n    }\n    &:-moz-placeholder {\n      color: rgba(0, 0, 0, 0.54) !important;\n    }\n  }\n  \n  button {\n    font-family: \"Raleway\";\n    background-color: #5ea1d8;\n    font-size: 15px;\n    cursor: pointer;\n    color: white;\n    padding: 10px;\n    border-radius: 10px;\n  }\n}\n\ninput[type=\"text\"],\ninput[type=\"password\"] {\n  background-color: #f6f6f6;\n  border: none;\n  color: #0d0d0d;\n  padding: 15px 32px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 16px;\n  margin: 5px;\n  width: 85%;\n  border: 2px solid #f6f6f6;\n  -webkit-transition: all 0.5s ease-in-out;\n  -moz-transition: all 0.5s ease-in-out;\n  -ms-transition: all 0.5s ease-in-out;\n  -o-transition: all 0.5s ease-in-out;\n  transition: all 0.5s ease-in-out;\n  -webkit-border-radius: 5px 5px 5px 5px;\n  border-radius: 5px 5px 5px 5px;\n}\n\ninput[type=\"text\"]:focus,\ninput[type=\"password\"]:focus {\n  background-color: #fff;\n  border-bottom: 2px solid #5fbae9;\n}\n\n/* ANIMATIONS */\n.fadeIn {\n  opacity: 0;\n  -webkit-animation: fadeIn ease-in 1;\n  -moz-animation: fadeIn ease-in 1;\n  animation: fadeIn ease-in 1;\n\n  -webkit-animation-fill-mode: forwards;\n  -moz-animation-fill-mode: forwards;\n  animation-fill-mode: forwards;\n\n  -webkit-animation-duration: 1s;\n  -moz-animation-duration: 1s;\n  animation-duration: 1s;\n}\n\n.fadeIn.first {\n  -webkit-animation-delay: 0.4s;\n  -moz-animation-delay: 0.4s;\n  animation-delay: 0.4s;\n}\n\n.fadeIn.second {\n  -webkit-animation-delay: 0.6s;\n  -moz-animation-delay: 0.6s;\n  animation-delay: 0.6s;\n  border: 0.5px solid lightgrey;\n}\n\n.fadeIn.fourth {\n  -webkit-animation-delay: 1s;\n  -moz-animation-delay: 1s;\n  animation-delay: 1s;\n  border: 0.5px solid lightgrey;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.img-div-left {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 10002;\n}\n\n@media (max-width: 460px) {\n  .Login {\n    & > div {\n      width: calc(100% - 30px);\n    }\n  }\n  \n  #formContent {\n    width: 100% !important;\n    input {\n      width: calc(100% - 30px);\n    }\n    .alert-danger {\n      width: calc(100% - 30px) !important;\n    }\n    .top-head {\n      padding: 20px 6px 0 5px;\n    }\n  }\n  \n  .alert-danger {\n    width: calc(100% - 30px) !important;\n    margin: 0px auto 1rem;\n  }\n}\n\n:host-context(body.theme-dark) {\n  .Login {\n    background-color: #0a0c10 !important;\n    color: #e5e7eb !important;\n  }\n\n  #formContent {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.2) !important;\n    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4) !important;\n    color: #e5e7eb !important;\n\n    .top-head {\n      color: #e5e7eb !important;\n    }\n\n    input {\n      background: #111827 !important;\n      color: #e5e7eb !important;\n      border-color: rgba(148, 163, 184, 0.3) !important;\n\n      &::-webkit-input-placeholder { color: rgba(229, 231, 235, 0.5) !important; }\n      &::-moz-placeholder { color: rgba(229, 231, 235, 0.5) !important; }\n      &:-ms-input-placeholder { color: rgba(229, 231, 235, 0.5) !important; }\n      &:-moz-placeholder { color: rgba(229, 231, 235, 0.5) !important; }\n    }\n\n    .auth-modal-close mat-icon {\n      color: #94a3b8 !important;\n    }\n\n    .auth-modal-close:hover {\n      background-color: rgba(255, 255, 255, 0.08) !important;\n    }\n\n    .auth-modal-close:hover mat-icon {\n      color: #e5e7eb !important;\n    }\n  }\n\n  input[type=\"text\"],\n  input[type=\"password\"] {\n    background-color: #111827 !important;\n    color: #e5e7eb !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  input[type=\"text\"]:focus,\n  input[type=\"password\"]:focus {\n    background-color: #1f2937 !important;\n    border-bottom-color: #5ea1d8 !important;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
